export const WORKFLOW_TRIGGER_TYPE_SCHEDULE = 'schedule'
export const WORKFLOW_TRIGGER_TYPE_EVENT = 'event'

export const WORKFLOW_TRIGGER_INTERVAL_MINUTE = 'MINUTE'
export const WORKFLOW_TRIGGER_INTERVAL_HOURLY = 'HOURLY'
export const WORKFLOW_TRIGGER_INTERVAL_DAILY = 'DAILY'
export const WORKFLOW_TRIGGER_INTERVAL_MONTHLY = 'MONTHLY'
export const WORKFLOW_TRIGGER_INTERVAL_EVERY_WEEK_DAY = 'EVERY_WEEK_DAY'
// export const WORKFLOW_TRIGGER_INTERVAL_FIRST_DAY_OF_MONTH = 'FIRST_DAY_OF_MONTH' - difference with monthly ?
export const WORKFLOW_TRIGGER_INTERVAL_15_DAY_OF_MONTH = '15_DAY_OF_MONTH'
export const WORKFLOW_TRIGGER_INTERVAL_CLOSEST_WEEK_DAY_TO_15_DAY_OF_MONTH = 'CLOSEST_WEEK_DAY_TO_15_DAY_OF_MONTH'
export const WORKFLOW_TRIGGER_INTERVAL_LAST_DAY_OF_THE_MONTH = 'LAST_DAY_OF_THE_MONTH'
export const WORKFLOW_TRIGGER_INTERVAL_LAST_WEEK_DAY_OF_THE_MONTH = 'LAST_WEEK_DAY_OF_THE_MONTH'
export const WORKFLOW_TRIGGER_INTERVAL_CUSTOM = 'CUSTOM'

export const workflowTriggerTypes = Object.freeze({
    [WORKFLOW_TRIGGER_TYPE_SCHEDULE]: {
        label: 'Scheduled',
        key: WORKFLOW_TRIGGER_TYPE_SCHEDULE
    },
    [WORKFLOW_TRIGGER_TYPE_EVENT]: {
        label: 'An Event',
        key: WORKFLOW_TRIGGER_TYPE_EVENT
    }
})

export const workflowTriggerTypesList = Object.freeze(Object.values(workflowTriggerTypes))

export const cronWeekDays = Object.freeze(['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'])

// cron here function if an interval with params else constant
export const scheduleIntervals = {
    [WORKFLOW_TRIGGER_INTERVAL_MINUTE]: {
        key: WORKFLOW_TRIGGER_INTERVAL_MINUTE,
        label: 'Every x minutes',
        cron: (min = 5) => {
            if (_.isInteger(min) && min >= 5 && min <= 60) {
                return `*/${min} * * * *`
            }
            return `*/5 * * * *`
        }
    },
    [WORKFLOW_TRIGGER_INTERVAL_HOURLY]: {
        key: WORKFLOW_TRIGGER_INTERVAL_HOURLY,
        label: 'Hourly',
        cron: '0 * * * *'
    },
    [WORKFLOW_TRIGGER_INTERVAL_DAILY]: {
        key: WORKFLOW_TRIGGER_INTERVAL_DAILY,
        label: 'Daily',
        cron: '0 0 * * *'
    },
    [WORKFLOW_TRIGGER_INTERVAL_MONTHLY]: {
        key: WORKFLOW_TRIGGER_INTERVAL_MONTHLY,
        label: 'Monthly',
        cron: '0 0 1 * *'
    },
    [WORKFLOW_TRIGGER_INTERVAL_EVERY_WEEK_DAY]: {
        key: WORKFLOW_TRIGGER_INTERVAL_EVERY_WEEK_DAY,
        label: 'Every week day',
        cron: (weekDayIdx = 0) => {
            if (cronWeekDays[weekDayIdx]) {
                return `0 0 * * ${weekDayIdx}`
            }
            return '0 0 * * 0'
        }
    },
    [WORKFLOW_TRIGGER_INTERVAL_15_DAY_OF_MONTH]: {
        key: WORKFLOW_TRIGGER_INTERVAL_15_DAY_OF_MONTH,
        label: 'On the 15th day of the month',
        cron: '0 0 15 * *'
    },
    [WORKFLOW_TRIGGER_INTERVAL_CLOSEST_WEEK_DAY_TO_15_DAY_OF_MONTH]: {
        key: WORKFLOW_TRIGGER_INTERVAL_CLOSEST_WEEK_DAY_TO_15_DAY_OF_MONTH,
        label: 'On the closest weekday to the 15th day of the month',
        cron: (weekDayIdx = 0) => {
            if (cronWeekDays[weekDayIdx]) {
                return `0 0 8-15 * ${weekDayIdx}`
            }
            return '0 0 8-15 * 0'
        }
    },
    [WORKFLOW_TRIGGER_INTERVAL_LAST_DAY_OF_THE_MONTH]: {
        key: WORKFLOW_TRIGGER_INTERVAL_LAST_DAY_OF_THE_MONTH,
        label: 'On the last day of the month',
        cron: '0 0 L * *'
    },
    [WORKFLOW_TRIGGER_INTERVAL_LAST_WEEK_DAY_OF_THE_MONTH]: {
        key: WORKFLOW_TRIGGER_INTERVAL_LAST_WEEK_DAY_OF_THE_MONTH,
        label: 'Last week day of the month',
        cron: '0 0 LW * *'
    },
    [WORKFLOW_TRIGGER_INTERVAL_CUSTOM]: {
        key: WORKFLOW_TRIGGER_INTERVAL_CUSTOM,
        label: 'Custom',
        cron: '* * * * *'
    }
}

export const scheduleIntervalsList = Object.freeze(Object.values(scheduleIntervals))

export const getScheduleIntervalByCron = cron => {
    if (scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_HOURLY].cron === cron) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_HOURLY}
    }
    if (scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_DAILY].cron === cron) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_DAILY}
    }
    if (scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_MONTHLY].cron === cron) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_MONTHLY}
    }
    if (scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_15_DAY_OF_MONTH].cron === cron) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_15_DAY_OF_MONTH}
    }
    if (scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_LAST_DAY_OF_THE_MONTH].cron === cron) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_LAST_DAY_OF_THE_MONTH}
    }
    if (scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_LAST_WEEK_DAY_OF_THE_MONTH].cron === cron) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_LAST_WEEK_DAY_OF_THE_MONTH}
    }

    let minute, weekDay
    minute = _.range(5, 59).find(min => scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_MINUTE].cron(min) === cron)
    if (minute) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_MINUTE, params: {minute}}
    }
    weekDay = cronWeekDays.findIndex((weekDay, idx) => scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_EVERY_WEEK_DAY].cron(idx) === cron)
    if (weekDay !== -1) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_EVERY_WEEK_DAY, params: {weekDay}}
    }
    weekDay = cronWeekDays.findIndex((weekDay, idx) => scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_CLOSEST_WEEK_DAY_TO_15_DAY_OF_MONTH].cron(idx) === cron)
    if (weekDay !== -1) {
        return {key: WORKFLOW_TRIGGER_INTERVAL_CLOSEST_WEEK_DAY_TO_15_DAY_OF_MONTH, params: {weekDay}}
    }

    return {key: WORKFLOW_TRIGGER_INTERVAL_CUSTOM, params: {}}
}
